// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { Util, DataSanitizer } from '@microsoft/applicationinsights-common';
import { getLocation } from '@microsoft/applicationinsights-core-js';
var TelemetryTrace = /** @class */ (function () {
    function TelemetryTrace(id, parentId, name, logger) {
        this.traceID = id || Util.generateW3CId();
        this.parentID = parentId;
        this.name = name;
        var location = getLocation();
        if (!name && location && location.pathname) {
            this.name = location.pathname;
        }
        this.name = DataSanitizer.sanitizeString(logger, this.name);
    }
    return TelemetryTrace;
}());
export { TelemetryTrace };
//# sourceMappingURL=TelemetryTrace.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-properties-js/dist-esm/Context/TelemetryTrace.js
// module id = 147
// module chunks = 1